import { useGetTagsByEventWithBulkFallback } from '@sunrise-ui/api-client';
import { MultiDropdown } from '@sunrise-ui/primitives';
import React from 'react';

type Props = {
  eventId: string;
  values: string[];
  onChange: (tagIds: string[]) => void;
  placeholder?: string;
  menuStyle?: object;
};

export function TagDropdown({
  eventId,
  values,
  onChange,
  placeholder = 'Select industries',
  menuStyle,
}: Props) {
  const { data: tags, isLoading } = useGetTagsByEventWithBulkFallback(eventId);

  const tagOptions =
    tags
      ?.filter((tag) => tag.id && tag.name)
      .map((tag) => ({
        label: tag.name!,
        value: tag.id!,
      })) || [];

  return (
    <MultiDropdown
      placeholder={placeholder}
      options={tagOptions}
      values={values}
      onChange={onChange}
      menuStyle={menuStyle}
      showLoadingState={isLoading}
    />
  );
}
